export const RESTAURANT_NAME = "La Piazza Genk";
export const RESTAURANT_ADDRESS = "Marktstraat 20, 3600 Genk";
export const RESTAURANT_PHONE = "+32 89 21 70 90";
export const RESTAURANT_PHONE_HREF = "tel:+3289217090";
export const RESTAURANT_EMAIL = "info@lapiazzagenk.be";
export const RESTAURANT_MAPS_URL = "https://maps.google.com/?q=La+Piazza+Genk+Marktstraat+20";
